module.exports = __webpack_public_path__ + "static/img/avatar_r_17.bb4ebede.png";